import { AfterViewInit, OnDestroy, Directive, inject, Component, ChangeDetectionStrategy } from "@angular/core";
import { Subscription } from "rxjs";
import { MatSelectChange } from "@angular/material/select";
import { toolbarOptions } from "../../../shared/model/toolbar-constants";
import { ViewerConstants } from "../../../shared/model/viewer-constants";
import { ToolbarService } from "../../services/internal-services/toolbar.service";
import { VIEWER_SERVICE } from "../../services/internal-services/viewer-services/inject-base-viewer.service";

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: "app-filter-view",
  templateUrl: "./filter.component.html",
  styleUrls: ["./filter.component.scss"],
  standalone: false,
})
export class FilterComponent implements AfterViewInit, OnDestroy {
  viewerService = inject(VIEWER_SERVICE);

  subscriptions: Subscription[] = [];

  displayPanel = false;

  toolbarOption = toolbarOptions.FILTER_TOOL;

  filters = ViewerConstants.FILTERS;

  constructor(private toolbarService: ToolbarService) {}

  ngAfterViewInit() {
    this.subscriptions.push(
      this.toolbarService.enabledTool$.subscribe((enabledTool) => {
        this.displayPanel = this.toolbarOption === enabledTool;
      }),
    );
  }

  ngOnDestroy() {
    this.subscriptions.forEach((sub: Subscription) => sub.unsubscribe());
  }

  togglePanelDisplay(): void {
    this.toolbarService.enableTool(!this.displayPanel ? this.toolbarOption : toolbarOptions.NONE);
  }

  selectFilter(event: MatSelectChange): void {
    this.viewerService.setFilterMask(event.value);
  }
}
